/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { VisualizationChooserActions } from '../actions/visualizationChooserActions';
import { IState } from '../store/types/StateTypes';
import { IReducerAction } from '../store/types/ReducerTypes';

export default function visualizationChooserReducers(state: IState, action: IReducerAction<any>) {
    let newState = state;

    if (action.type === VisualizationChooserActions.VISUALIZATION_CHOOSER_VISIBILITY) {
        newState = {
            ...state,
            visualizationChooser: {
                ...state.visualizationChooser,
                isVisible: action.data.isVisible
            }
        };
    }

    if (action.type === VisualizationChooserActions.VISUALIZATION_CHOOSER_TAB_COLLAPSED) {
        newState = {
            ...state,
            visualizationChooser: {
                ...state.visualizationChooser,
                isCollapsed: action.data.isCollapsed
            }
        };
    }

    if (action.type === VisualizationChooserActions.VISUALIZATION_CHOOSER_SELECTED_GROUP) {
        newState = {
            ...state,
            visualizationChooser: {
                ...state.visualizationChooser,
                selectedGroup: action.data.groupName
            }
        };
    }

    if (action.type === VisualizationChooserActions.VISUALIZATION_CHOOSER_SELECTED_TYPE) {

        const
            selectedVisualizationType = state.visualizationTypesRegistry.find((item: any): boolean => {
                return item.descriptor.name === action.data.visualizationTypeName;
            });

        if (selectedVisualizationType) {
            const { canvas } = state;
            let newCanvas;
            if (canvas) {
                newCanvas = {
                    ...canvas,
                    type: selectedVisualizationType.descriptor.name
                }
            } else {
                newCanvas = {
                    type: selectedVisualizationType.descriptor.name,
                    properties: {}
                }
            }

            newState = {
                ...state,
                canvas: newCanvas,
                visualizationDescriptor: selectedVisualizationType.descriptor
            };
        }
    }

    return newState;
}
